import fetchJsonp from 'fetch-jsonp';
import { SettingActionType } from '../state/action-types/settingTypes';
import store from '../state/store';
import { Payments } from '../settings/enums';
import Helper from '../settings/helperFunctions';
import { parse, format, isValid as isValidDate } from 'date-fns';
const currentSteps = store.getState().settingsReducer.currentSteps;

type PayPageHandlesRequestBody = {
  premium: number;
  payPageLocale: string;
  ccHolder: {
    firstName: string;
    lastName: string;
    email: string;
    iso2CountryOfResidence: string;
    addressCity: string;
    addressPostalCode: string;
    addressStreetAndNo: string;
  };
};

const getAPIEndpoint = () => {
  const DEV_API_URL = 'http://localhost:14080/';
  const TEST_API_URL = 'https://egate3.erv.de/';
  const INT_API_URL = 'https://egate2.erv.de/';
  const PROD_API_URL = 'https://egate.erv.de/';

  const environment = store.getState().settingsReducer.environment;
  if (environment === 'PROD') {
    return PROD_API_URL;
  } else if (environment === 'INT') {
    return INT_API_URL;
  } else if (environment === 'TEST') {
    return TEST_API_URL;
  } else if (environment === 'DEV') {
    return INT_API_URL; // for backend test DEV_API_URL
  }
};

const getAPPRoot = () => {
  let DEV_ROOT_URL = 'http://localhost:3000/ba4/';
  //  for testing from the Wilfdfly
  if (window.location.href.indexOf('localhost:14080') !== -1)
    DEV_ROOT_URL = 'http://localhost:14080/ba4/';
  const TEST_ROOT_URL = 'https://app3.ergo-reiseversicherung.de/ba4/';
  const INT_ROOT_URL = 'https://app2.ergo-reiseversicherung.de/ba4/';
  const PROD_ROOT_URL = 'https://app.ergo-reiseversicherung.de/ba4/';

  const environment = store.getState().settingsReducer.environment;
  if (environment === 'PROD') {
    return PROD_ROOT_URL;
  } else if (environment === 'INT') {
    return INT_ROOT_URL;
  } else if (environment === 'TEST') {
    return TEST_ROOT_URL;
  } else if (environment === 'DEV') {
    return DEV_ROOT_URL;
  }
};

export async function logError(message: string, error?: unknown) {
  let errorMessage = error;
  if (error instanceof Error) {
    errorMessage = error.stack;
  }
  logs(message + ' ' + errorMessage, 'ERROR');
}

export async function logs(message: string, type: 'ERROR' | 'INFO' | 'BEINFOMAILS' = 'ERROR') {
  let data = {
    type: type,
    message: message,
  };
  const url = `${getAPIEndpoint()}ervSalesGate/v1/riskcarriers/ERVDE/applications/logs`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        sessionId: store.getState().settingsReducer.sessionId,
      },
      body: JSON.stringify(data),
    });
  } catch (err) {}
}

export async function initApp(
  sessionId: string,
  data: InitAppRequestBody,
  appName: string,
  onSuccess: any,
) {
  const url = `${getAPIEndpoint()}ervSalesGate/v1/riskcarriers/ERVDE/applications/start`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        sessionId: sessionId,
      },
      body: JSON.stringify(data),
    });
    const initApp = await res.json();
    if (!res.ok) {
      if (
        (initApp.message && initApp.message.indexOf('partnerId') !== -1) ||
        (initApp.code && initApp.code === 1)
      ) {
        onSuccess('ba-error', 'PartnerID');
        logs(
          "BA40\n Parameter 'PartnerId' not correct: " +
            JSON.stringify(data) +
            '\n URL: ' +
            document.location.href +
            '\n Referrer: ' +
            Helper.getReferrertUrl(),
          'BEINFOMAILS',
        );
      } else if (initApp.message && initApp.message.indexOf('parameters.agent') !== -1) {
        onSuccess('ba-error', 'Agent');
        logs(
          "BA40\n Parameter 'Agent' not correct: " +
            JSON.stringify(data) +
            '\n URL: ' +
            document.location.href +
            '\n Referrer: ' +
            Helper.getReferrertUrl(),
          'BEINFOMAILS',
        );
      } else if (initApp.code && initApp.code === 4) {
        onSuccess('ba-error', 'ConfirmationTarget');
        logs(
          "BA40\n Parameter 'ConfirmationTarget' not correct: " +
            JSON.stringify(data) +
            '\n URL: ' +
            document.location.href +
            '\n Referrer: ' +
            Helper.getReferrertUrl(),
          'BEINFOMAILS',
        );
      } else if (initApp.code && initApp.code === 5) {
        onSuccess('ba-error', 'ConfirmationType');
        logs(
          "BA40\n Parameter 'ConfirmationType' not correct: " +
            JSON.stringify(data) +
            '\n URL: ' +
            document.location.href +
            '\n Referrer: ' +
            Helper.getReferrertUrl(),
          'BEINFOMAILS',
        );
      } else {
        onSuccess('ba-error', null);
      }
      return;
    }
    let agencyInfo: AgencyInformationType = {
      ergoOrganisationUnitType: {
        name: '',
        organisation1Number: {
          required: false,
          readonly: false,
          visible: false,
        },
        organisation1Percent: {
          required: false,
          readonly: false,
          visible: false,
        },
        organisation2Number: {
          required: false,
          readonly: false,
          visible: false,
        },
        organisation2Percent: {
          required: false,
          readonly: false,
          visible: false,
        },
        advertisingMaterialKey: {
          required: false,
          readonly: false,
          visible: false,
        },
        wayOfAccess: {
          required: false,
          readonly: false,
          visible: false,
        },
        tipster: {
          required: false,
          readonly: false,
          visible: false,
        },
        productionDST: {
          required: false,
          readonly: false,
          visible: false,
        },
      },
      hotline: {
        phone: '',
        serviceTime: '',
      },
      isMecklenburgische: false,
      isWuerttembergische: false,
      isMilesMore: false,
    };
    if (initApp.agencyInformation) {
      if (initApp.agencyInformation.ergoOrganisationUnitTyp) {
        if (initApp.agencyInformation.ergoOrganisationUnitTyp.name)
          agencyInfo.ergoOrganisationUnitType.name =
            initApp.agencyInformation.ergoOrganisationUnitTyp.name;

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Number) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Number.required)
            agencyInfo.ergoOrganisationUnitType.organisation1Number.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Number.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Number.readonly)
            agencyInfo.ergoOrganisationUnitType.organisation1Number.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Number.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Number.visible)
            agencyInfo.ergoOrganisationUnitType.organisation1Number.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Number.visible;
        }

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Percent) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Percent.required)
            agencyInfo.ergoOrganisationUnitType.organisation1Percent.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Percent.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Percent.readonly)
            agencyInfo.ergoOrganisationUnitType.organisation1Percent.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Percent.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Percent.visible)
            agencyInfo.ergoOrganisationUnitType.organisation1Percent.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation1Percent.visible;
        }

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Number) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Number.required)
            agencyInfo.ergoOrganisationUnitType.organisation2Number.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Number.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Number.readonly)
            agencyInfo.ergoOrganisationUnitType.organisation2Number.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Number.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Number.visible)
            agencyInfo.ergoOrganisationUnitType.organisation2Number.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Number.visible;
        }

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Percent) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Percent.required)
            agencyInfo.ergoOrganisationUnitType.organisation2Percent.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Percent.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Percent.readonly)
            agencyInfo.ergoOrganisationUnitType.organisation2Percent.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Percent.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Percent.visible)
            agencyInfo.ergoOrganisationUnitType.organisation2Percent.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.organisation2Percent.visible;
        }

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.advertisingMaterialKey) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.advertisingMaterialKey.required)
            agencyInfo.ergoOrganisationUnitType.advertisingMaterialKey.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.advertisingMaterialKey.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.advertisingMaterialKey.readonly)
            agencyInfo.ergoOrganisationUnitType.advertisingMaterialKey.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.advertisingMaterialKey.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.advertisingMaterialKey.visible)
            agencyInfo.ergoOrganisationUnitType.advertisingMaterialKey.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.advertisingMaterialKey.visible;
        }

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.wayOfAccess) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.wayOfAccess.required)
            agencyInfo.ergoOrganisationUnitType.wayOfAccess.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.wayOfAccess.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.wayOfAccess.readonly)
            agencyInfo.ergoOrganisationUnitType.wayOfAccess.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.wayOfAccess.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.wayOfAccess.visible)
            agencyInfo.ergoOrganisationUnitType.wayOfAccess.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.wayOfAccess.visible;
        }

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.tipster) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.tipster.required)
            agencyInfo.ergoOrganisationUnitType.tipster.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.tipster.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.tipster.readonly)
            agencyInfo.ergoOrganisationUnitType.tipster.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.tipster.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.tipster.visible)
            agencyInfo.ergoOrganisationUnitType.tipster.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.tipster.visible;
        }

        if (initApp.agencyInformation.ergoOrganisationUnitTyp.productionDST) {
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.productionDST.required)
            agencyInfo.ergoOrganisationUnitType.productionDST.required =
              initApp.agencyInformation.ergoOrganisationUnitTyp.productionDST.required;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.productionDST.readonly)
            agencyInfo.ergoOrganisationUnitType.productionDST.readonly =
              initApp.agencyInformation.ergoOrganisationUnitTyp.productionDST.visible;
          if (initApp.agencyInformation.ergoOrganisationUnitTyp.productionDST.visible)
            agencyInfo.ergoOrganisationUnitType.productionDST.visible =
              initApp.agencyInformation.ergoOrganisationUnitTyp.productionDST.visible;
        }
      }
      if (initApp.agencyInformation.hotline) {
        if (initApp.agencyInformation.hotline.phone)
          agencyInfo.hotline.phone = initApp.agencyInformation.hotline.phone;
        if (initApp.agencyInformation.hotline.serviceTime)
          agencyInfo.hotline.serviceTime = initApp.agencyInformation.hotline.serviceTime;
      }
      if (initApp.agencyInformation.mecklenburgische) {
        agencyInfo.isMecklenburgische = true;
      }
      if (initApp.agencyInformation.wuerttembergische) {
        agencyInfo.isWuerttembergische = true;
      }
      if (initApp.agencyInformation.milesMore) {
        agencyInfo.isMilesMore = true;
      }
      const iApp: InitAppType = {
        agencyInfo: agencyInfo,
        currentDate: initApp.currentDate,
      };
      onSuccess(appName, null, iApp);
    }
  } catch (error) {
    onSuccess('ba-error', null);
    if (window.DEBUG) console.log(`fetchAppConfig ${error}`);
    //logError('initApp', error); <- no need to log this error this is network error
  }
}

export async function fetchAppConfig(sessionId: string, onSuccess: any) {
  const appRoot = getAPPRoot();
  const appName = store.getState().settingsReducer.appName;
  const url = `${appRoot}de-${appName}.json`;
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    if (!res.ok || !res.headers.get('content-type')?.match(/application\/json/)) {
      throw Error(`${res.status} ${res.statusText}: ${url}`);
    }
    const appConfig = await res.json();
    onSuccess(appConfig);
  } catch (error) {
    if (window.DEBUG) console.log(`fetchAppConfig ${error}`);
    //logError('fetchAppConfig', error); <- no need to log this error this is network error
  }
}

export async function fetchSkinConfig(url: string, onSuccess: any) {
  if (url) {
    try {
      const res = await fetchJsonp(url, {
        jsonpCallbackFunction: 'skinconfig',
      });
      if (!res.ok) {
        throw Error();
      }
      const appSkin = await res.json();
      onSuccess(appSkin);
    } catch (error) {
      if (window.DEBUG) console.log(`fetchSkinConfig ${error}`);
      logError('fetchSkinConfig', error);
      onSuccess(null);
    }
  }
  onSuccess(null);
}

export async function productPlanSearch(
  sessionId: string,
  data: ProductPlanRequestBody,
  onSuccess: any,
) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const url = `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/products/plansearches`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        sessionId: sessionId,
      },
      body: JSON.stringify(data),
    });

    if (response.status === 400) {
      const text = await response.json();
      throw Error(text);
    }

    if (response.headers.get('content-type')?.match(/application\/json/)) {
      const responseJSON = await response.json();
      onSuccess(responseJSON);
      return responseJSON;
    }

    return response;
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: Plan search: ', error);
  }
}

export async function uploadExcelFile(sessionId: string, file: File, onSuccess: any) {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await fetch(`${getAPIEndpoint()}ervSalesGate/excelToJSONParser`, {
      method: 'POST',
      body: formData,
    });
    if (response.ok) {
      const jsonResponse = await response.json();
      onSuccess(jsonResponse, 200);
    } else {
      onSuccess(null, response.status);
    }
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('uploadExcelFile', error);
  }
}

export async function validatePersons(
  sessionId: string,
  data: ContractRequestBody,
  callbackResponse: any,
) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const response = await fetch(
      `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/contracts?validationMode=person`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          sessionId: sessionId,
        },
        body: JSON.stringify(data),
      },
    );

    if (String(response.status).startsWith('2')) {
      const responseJSON = { code: 1000, message: 'success' };
      callbackResponse(responseJSON);
      return responseJSON;
    } else {
      if (response.status === 400 || response.status === 422) {
        const text = await response.text();
        throw new Error(text);
      }
      const responseJSON = await response.json();
      callbackResponse(responseJSON);
      return responseJSON;
    }
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: Validate persons: ', error);
  }
}

export async function createPrecontractualInfo(
  sessionId: string,
  data: PrecontractualInfoRequestBody,
  onSuccess: any,
) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const response = await fetch(
      `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/products/precontractualdocuments`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          sessionId: sessionId,
        },
        body: JSON.stringify(data),
      },
    );

    if (response.status === 400) {
      const text = await response.text();
      throw new Error(text);
    }

    if (response.headers.get('content-type')?.match(/application\/json/)) {
      const responseJSON = await response.json();
      onSuccess(responseJSON);
      return responseJSON;
    }

    onSuccess(response);
    return response;
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: Precontractual info: ', error);
  }
}

export async function sendPrecontractualInfo(
  sessionId: string,
  preciId: string,
  partnerId: string,
  sectoken: string,
  onSuccess: any,
) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const response = await fetch(
      `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/products/precontractualdocuments/${preciId}?partnerId=${partnerId}&sectoken=${sectoken}&language=de&senddocuments=true`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          sessionId: sessionId,
        },
      },
    );

    if (response.status === 400) {
      const text = await response.text();
      logError(text);
    } else {
      onSuccess();
    }
    return response;
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: Precontractual info send: ', error);
  }
}

export async function validatePersonsAndPayment(
  sessionId: string,
  data: ContractRequestBody,
  callbackResponse: any,
) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const response = await fetch(
      `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/contracts?validationMode=person_and_payment`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          sessionId: sessionId,
        },
        body: JSON.stringify(data),
      },
    );

    if (String(response.status).startsWith('2')) {
      const responseJSON = { code: 1000, message: 'success' };
      callbackResponse(responseJSON);
      return responseJSON;
    } else {
      const responseJSON = await response.json();
      callbackResponse(responseJSON);
      return responseJSON;
    }
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: Validate persons and payment: ', error);
  }
}
export async function validateErgoOrganisationUnit(
  sessionId: string,
  data: ContractRequestBody,
  callbackResponse: any,
) {
  try {
    const apiEndpoint = getAPIEndpoint();

    const response = await fetch(
      `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/contracts?validationMode=ergo_organisation_unit`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          sessionId: sessionId,
        },
        body: JSON.stringify(data),
      },
    );

    if (String(response.status).startsWith('2')) {
      const responseJSON = { code: 1000, message: 'success' };
      callbackResponse(responseJSON);
      return responseJSON;
    } else {
      const responseJSON = await response.json();
      callbackResponse(responseJSON);
      return responseJSON;
    }
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: Validate ERGO Organisation Unit: ', error);
  }
}

export async function payPageHandles(
  sessionId: string,
  data: PayPageHandlesRequestBody,
  onSuccess: any,
) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const response = await fetch(
      `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/payments/cc/providers/bs/paypagehandles`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          sessionId: sessionId,
        },
        body: JSON.stringify(data),
      },
    );

    if (response.status === 400 || response.status === 503) {
      const text = await response.text();
      throw Error(text);
    }

    if (response.headers.get('content-type')?.match(/application\/json/)) {
      const responseJSON = await response.json();
      onSuccess(responseJSON);
      return responseJSON;
    }

    onSuccess(response);
    return response;
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: PayPage: ', error);
  }
}

export async function paypalToken(sessionId: string, onSuccess: any) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const response = await fetch(
      `${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/payments/paypal/providers/braintree/paypaltokens`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          sessionId: sessionId,
        },
      },
    );

    if (response.status === 400) {
      const text = await response.text();
      throw Error(text);
    }

    if (response.headers.get('content-type')?.includes('application/json')) {
      const responseJSON = await response.json();
      onSuccess(responseJSON);
      return responseJSON;
    }

    onSuccess(response);
    return response;
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: PayPal: ', error);
  }
}

export async function createContract(sessionId: string, data: ContractRequestBody, onSuccess: any) {
  try {
    const apiEndpoint = getAPIEndpoint();
    const response = await fetch(`${apiEndpoint}ervSalesGate/v1/riskcarriers/ERVDE/contracts`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        sessionId: sessionId,
      },
      body: JSON.stringify(data),
    });

    if (
      response.headers.get('content-type')?.match(/application\/json/) &&
      (response.status === 400 || response.status === 422)
    ) {
      const errorJSON = await response.json();
      onSuccess(errorJSON, null);
      return errorJSON;
    }

    if (response.headers.get('content-type')?.match(/application\/json/)) {
      const responseJSON = await response.json();
      onSuccess(null, responseJSON);
      return responseJSON;
    }
  } catch (error) {
    store.dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: [...currentSteps, 1000],
    });
    logError('ERROR SCREEN: Contract: ', error);
  }
}

export async function validateEmailAddress(
  sessionId: string,
  emailAddress: string,
): Promise<boolean> {
  try {
    const response = await fetch(`${getAPIEndpoint()}ervSalesGate/validateEmailAddress`, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain',
        sessionId: sessionId,
      },
      body: emailAddress,
    });

    if (response.ok) {
      const responseBody: boolean = await response.json();
      return responseBody;
    } else {
      logError(`HTTP Error: ${response.status} ${response.statusText}.`);
      return true;
    }
  } catch (error) {
    logError('validateEmailAddress', error);
    return true;
  }
}

const buildProductPlanRequestPersons = (
  travelers: TravelersType,
  persons: Array<Person>,
): Array<ProductPlanRequestPerson> => {
  let tmpArray: Array<ProductPlanRequestPerson> = [];
  if (travelers.adultsUpTo40 && travelers.adultsUpTo40 > 0) {
    [...Array(travelers.adultsUpTo40)].map((_, i) => {
      let element: ProductPlanRequestPerson = {
        id: i,
        age: 30,
        ageType: 'adultsUpTo40',
      };
      if (persons[i]?.individualTripCost) {
        element.individualTripCost = persons[i]?.individualTripCost;
      }
      return tmpArray.push(element);
    });
  }

  // Handle travelers upto 64
  if (travelers.adultsUpTo64 && travelers.adultsUpTo64 > 0) {
    [...Array(travelers.adultsUpTo64)].map((_, i) => {
      let element: ProductPlanRequestPerson = {
        id: (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) + i,
        age: 45, // Example age for upto 64
        ageType: 'adultsUpTo64',
      };
      if (persons[(travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) + i]?.individualTripCost) {
        element.individualTripCost =
          persons[(travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) + i]?.individualTripCost;
      }
      return tmpArray.push(element);
    });
  }

  // Handle travelers from 65
  if (travelers.adultsFrom65 && travelers.adultsFrom65 > 0) {
    [...Array(travelers.adultsFrom65)].map((_, j) => {
      let element: ProductPlanRequestPerson = {
        id:
          (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
          (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
          j,
        age: 70, // Example age for from 65
        ageType: 'adultsFrom65',
      };
      if (
        persons[
          (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
            (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
            j
        ]?.individualTripCost
      ) {
        element.individualTripCost =
          persons[
            (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
              (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
              j
          ]?.individualTripCost;
      }
      return tmpArray.push(element);
    });
  }

  if (travelers.children && travelers.children > 0) {
    [...Array(travelers.children)].map((_, k) => {
      let element: ProductPlanRequestPerson = {
        id:
          (travelers.adultsFrom65 ? travelers.adultsFrom65 : 0) +
          (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
          (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
          k,
        age: 18,
        ageType: 'children',
      };
      if (
        persons[
          (travelers.adultsFrom65 ? travelers.adultsFrom65 : 0) +
            (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
            (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
            k
        ]?.individualTripCost
      ) {
        element.individualTripCost =
          persons[
            (travelers.adultsFrom65 ? travelers.adultsFrom65 : 0) +
              (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
              (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
              k
          ]?.individualTripCost;
      }
      return tmpArray.push(element);
    });
  }

  if (travelers.complementary && travelers.complementary > 0) {
    [...Array(travelers.complementary)].map((_, f) => {
      let element: ProductPlanRequestPerson = {
        id:
          (travelers.adultsFrom65 ? travelers.adultsFrom65 : 0) +
          (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
          (travelers.children ? travelers.children : 0) +
          (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
          f,
        age: 30,
        ageType: 'adultsUpTo40',
      };
      if (
        persons[
          (travelers.adultsFrom65 ? travelers.adultsFrom65 : 0) +
            (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
            (travelers.children ? travelers.children : 0) +
            (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
            f
        ]?.individualTripCost
      ) {
        element.individualTripCost =
          persons[
            (travelers.adultsFrom65 ? travelers.adultsFrom65 : 0) +
              (travelers.adultsUpTo64 ? travelers.adultsUpTo64 : 0) +
              (travelers.children ? travelers.children : 0) +
              (travelers.adultsUpTo40 ? travelers.adultsUpTo40 : 0) +
              f
          ]?.individualTripCost;
      }
      return tmpArray.push(element);
    });
  }

  return tmpArray;
};

export function buildPlanSearchRequestBody() {
  const BookingState = store.getState().bookingReducer;
  const SettingState = store.getState().settingsReducer;
  const ConfigState = store.getState().configReducer.properties;
  let tmp: ProductPlanRequestBody = {
    parameters: {
      languageCode: 'de',
      currencyCode: 'EUR',
      partnerId: SettingState.partnerId,
    },
    trip: {
      startDate: BookingState.startDate,
      endDate: BookingState.endDate,
      bookingConfirmationDate: BookingState.bookingConfirmationDate,
    },
    persons: buildProductPlanRequestPersons(BookingState.travelers, BookingState.persons),
    productListName: ConfigState.productListName,
  };
  if (BookingState.geographicalZone !== undefined) {
    tmp['trip']['geographicalZone'] = BookingState.geographicalZone;
  } else if (ConfigState.defaultGeographicalZone) {
    tmp['trip']['geographicalZone'] = ConfigState.defaultGeographicalZone;
  }
  if (BookingState.tripCost !== undefined) {
    tmp['trip']['totalTripCost'] = BookingState.tripCost;
  }
  if (BookingState.rental !== undefined) {
    tmp['trip']['rental'] = BookingState.rental;
  }
  if (BookingState.excessAmount > 0) {
    tmp['trip']['totalCoveredKasko'] = BookingState.excessAmount;
  }
  if (BookingState.meansOfTravel) {
    tmp['trip']['meansOfTravel'] = BookingState.meansOfTravel;
  } else if (ConfigState.defaultMeansOfTravel) {
    tmp['trip']['meansOfTravel'] = ConfigState.defaultMeansOfTravel;
  }
  if (ConfigState.defaultBookingConfirmationDate === true) {
    tmp.trip.bookingConfirmationDate = new Date().toLocaleDateString('fr-CA', {
      timeZone: 'Europe/Berlin',
    });
  }
  if (SettingState.tipmode) {
    tmp.parameters.partnerIdSu = ConfigState.defaultPartnerId;
  }
  if (ConfigState.versObjectTypeDefinition) {
    tmp.parameters.versObjectTypeDefinition = ConfigState.versObjectTypeDefinition;
  }
  return tmp;
}

export function buildContractRequestBodyValidatePerson() {
  const BookingState = store.getState().bookingReducer;
  const ProductState = store.getState().productsReducer;
  const SettingState = store.getState().settingsReducer;
  const ConfigState = store.getState().configReducer.properties;
  let tmp: ContractRequestBody = {
    parameters: {
      languageCode: 'de',
      currencyCode: 'EUR',
      partnerId: SettingState.partnerId,
    },
    clientId: ConfigState.clientId,
    productCategory: ConfigState.productCategory,
    quoteId: ProductState.selectedProduct?.quote.quoteId
      ? ProductState.selectedProduct?.quote.quoteId
      : 0,
    products: [ProductState.selectedProduct ? ProductState.selectedProduct.tarifmatrix : ''],
    trip: {
      startDate: BookingState.startDate,
      endDate: BookingState.endDate,
      bookingConfirmationDate: BookingState.bookingConfirmationDate,
    },
    preciId: null,
    policyHolder: {
      salutation: BookingState.policyHolderSalutation ? BookingState.policyHolderSalutation : 'Mr',
      firstName: BookingState.policyHolderFirstName,
      lastName: BookingState.policyHolderLastName,
      company: null,
      street1: BookingState.policyHolderStreet,
      zipCode: BookingState.policyHolderPostalCode,
      city: BookingState.policyHolderCity,
      isoCountry: BookingState.policyHolderCountry,
      mobile: BookingState.policyHolderPhone,
      email: BookingState.policyHolderEmail,
    },
    payment: null,
    ergoOrganisationUnitIn: null,
  };

  if (SettingState.tipmode) {
    tmp.parameters.partnerIdSu = ConfigState.defaultPartnerId;
  }
  if (ConfigState.versObjectTypeDefinition) {
    tmp.parameters.versObjectTypeDefinition = ConfigState.versObjectTypeDefinition;
  }
  if (BookingState.agent !== '') {
    tmp.parameters.agent = BookingState.agent;
  }
  if (SettingState.externalReference !== '') {
    tmp.parameters.externalReference = SettingState.externalReference;
  }
  if (SettingState.confirmationtarget && SettingState.confirmationtype) {
    tmp.parameters.confirmation = {};
    tmp.parameters.confirmation.target = SettingState.confirmationtarget;
    tmp.parameters.confirmation.type = SettingState.confirmationtype;
    if (SettingState.rebound && SettingState.rebound.keys.length != 0) {
      tmp.parameters.confirmation.rebound = SettingState.rebound;
    }
  }
  if (BookingState.policyHolderSalutation === 'Company') {
    tmp.policyHolder.company = BookingState.policyHolderCompany;
    tmp.policyHolder.lastName = BookingState.policyHolderCompany;
    delete tmp.policyHolder.firstName;
  }
  if (ProductState.selectedProduct?.tarifmatrixGeographicalZone !== undefined) {
    tmp['trip']['geographicalZone'] = ProductState.selectedProduct?.tarifmatrixGeographicalZone;
  } else if (BookingState.geographicalZone !== undefined) {
    tmp['trip']['geographicalZone'] = BookingState.geographicalZone;
  } else if (ConfigState.defaultGeographicalZone) {
    tmp['trip']['geographicalZone'] = ConfigState.defaultGeographicalZone;
  }
  if (BookingState.tripCost !== undefined) {
    tmp['trip']['totalTripCost'] = BookingState.tripCost;
  }
  if (BookingState.rental !== undefined) {
    tmp['trip']['rental'] = BookingState.rental;
  }
  if (BookingState.excessAmount > 0) {
    tmp['trip']['totalCoveredKasko'] = BookingState.excessAmount;
  }
  if (BookingState.meansOfTravel) {
    tmp['trip']['meansOfTravel'] = BookingState.meansOfTravel;
  } else if (ConfigState.defaultMeansOfTravel) {
    tmp['trip']['meansOfTravel'] = ConfigState.defaultMeansOfTravel;
  }
  if (ConfigState.defaultBookingConfirmationDate === true) {
    tmp.trip.bookingConfirmationDate = new Date().toLocaleDateString('fr-CA', {
      timeZone: 'Europe/Berlin',
    });
  }

  let persons = Array<Person>();
  if (BookingState.persons) {
    [...BookingState.persons].forEach((p: Person) => {
      let person: Person = {
        id: p.id,
        index: p.index,
        firstName: p.firstName,
        lastName: p.lastName,
        age: p.age,
        ageType: p.ageType,
      };
      if (p.individualTripCost && p.individualTripCost !== 0) {
        person['individualTripCost'] = p.individualTripCost;
      }
      if (p.birthDate) {
        const birthDate = parse(p.birthDate, 'dd.MM.yyyy', new Date());
        if (isValidDate(birthDate)) {
          person.birthDate = format(birthDate, 'yyyy-MM-dd');
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(p.birthDate)) {
          person.birthDate = p.birthDate;
        }
        // If p.birthDate is not valid, do not add it
      }
      persons.push(person);
    });
  }
  tmp.persons = persons;
  return tmp;
}
export function buildContractRequestBodyValidatePersonAndPayment() {
  const BookingState = store.getState().bookingReducer;
  const ProductState = store.getState().productsReducer;
  const SettingsState = store.getState().settingsReducer;
  let tmp: ContractRequestBody = buildContractRequestBodyValidatePerson();

  if (ProductState.precontractualInfo) tmp.preciId = ProductState.precontractualInfo.id;

  if (BookingState.paymentMethod === Payments.SEPA) {
    tmp.payment = {
      paymentMethod: 'direct_debit',
      ddPaymentIn: {
        accountHolderIsPolicyHolder: true,
        iban: BookingState.policyHolderIBAN,
      },
    };
  } else if (BookingState.paymentMethod === Payments.Creditcard) {
    tmp.payment = {
      paymentMethod: 'credit_card',
      ccPaymentIn: { payPageHandleId: ProductState.payPageHandles?.handleId },
    };
  } else {
    tmp.payment = { paymentMethod: 'paypal', ppPaymentIn: { nonce: ProductState.paypalNounce } };
  }
  if (SettingsState.agencyInformation && SettingsState.agencyInformation.ergoOrganisationUnitType) {
    let ergoOrganisationUnitBody: ErgoOrganisationUnitBodyType = {
      oe1: {
        oenr: null,
        percentage: null,
      },
      oe2: {
        oenr: null,
        percentage: null,
        tipster: null,
      },
      advertisingMaterialKey: null,
      wayOfAccessKey: null,
      productionDST: null,
    };
    ergoOrganisationUnitBody.oe1.oenr = BookingState.ergoOrganisationUnit.organisation1Number;
    ergoOrganisationUnitBody.wayOfAccessKey = BookingState.ergoOrganisationUnit.wayOfAccess;

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.organisation1Percent.visible) {
      ergoOrganisationUnitBody.oe1.percentage =
        BookingState.ergoOrganisationUnit.organisation1Percent;
    } else {
      ergoOrganisationUnitBody.oe1.percentage = 100;
    }
    if (BookingState.ergoOrganisationUnit.organisation2Number && ergoOrganisationUnitBody.oe2) {
      if (SettingsState.agencyInformation.ergoOrganisationUnitType.organisation2Number.visible) {
        ergoOrganisationUnitBody.oe2.oenr = BookingState.ergoOrganisationUnit.organisation2Number;
      }
      if (SettingsState.agencyInformation.ergoOrganisationUnitType.organisation2Percent.visible) {
        ergoOrganisationUnitBody.oe2.percentage =
          BookingState.ergoOrganisationUnit.organisation2Percent;
      }
      if (SettingsState.agencyInformation.ergoOrganisationUnitType.tipster.visible) {
        ergoOrganisationUnitBody.oe2.tipster = BookingState.ergoOrganisationUnit.tipster;
      }
    } else {
      delete ergoOrganisationUnitBody.oe2;
    }

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.advertisingMaterialKey.visible) {
      ergoOrganisationUnitBody.advertisingMaterialKey =
        BookingState.ergoOrganisationUnit.advertisingMaterialKey;
    }
    if (!ergoOrganisationUnitBody.advertisingMaterialKey)
      delete ergoOrganisationUnitBody.advertisingMaterialKey;

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.wayOfAccess.visible) {
      ergoOrganisationUnitBody.wayOfAccessKey = BookingState.ergoOrganisationUnit.wayOfAccess;
    }
    if (!ergoOrganisationUnitBody.wayOfAccessKey) delete ergoOrganisationUnitBody.wayOfAccessKey;

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.productionDST.visible) {
      ergoOrganisationUnitBody.productionDST = BookingState.ergoOrganisationUnit.productionDST;
    }
    if (!ergoOrganisationUnitBody.productionDST) delete ergoOrganisationUnitBody.productionDST;

    tmp.ergoOrganisationUnitIn = ergoOrganisationUnitBody;
  }
  return tmp;
}
export function buildContractRequestBodyValidateErgoOrganisationUnit() {
  const BookingState = store.getState().bookingReducer;
  const ProductState = store.getState().productsReducer;

  const SettingsState = store.getState().settingsReducer;

  let tmp: ContractRequestBody = buildContractRequestBodyValidatePerson();

  delete tmp.payment;

  if (ProductState.precontractualInfo) tmp.preciId = ProductState.precontractualInfo.id;

  if (SettingsState.agencyInformation && SettingsState.agencyInformation.ergoOrganisationUnitType) {
    let ergoOrganisationUnitBody: ErgoOrganisationUnitBodyType = {
      oe1: {
        oenr: null,
        percentage: null,
      },
      oe2: {
        oenr: null,
        percentage: null,
        tipster: null,
      },
      advertisingMaterialKey: null,
      wayOfAccessKey: null,
      productionDST: null,
    };
    ergoOrganisationUnitBody.oe1.oenr = BookingState.ergoOrganisationUnit.organisation1Number;
    ergoOrganisationUnitBody.wayOfAccessKey = BookingState.ergoOrganisationUnit.wayOfAccess;

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.organisation1Percent.visible) {
      ergoOrganisationUnitBody.oe1.percentage =
        BookingState.ergoOrganisationUnit.organisation1Percent;
    } else {
      ergoOrganisationUnitBody.oe1.percentage = 100;
    }
    if (BookingState.ergoOrganisationUnit.organisation2Number && ergoOrganisationUnitBody.oe2) {
      if (SettingsState.agencyInformation.ergoOrganisationUnitType.organisation2Number.visible) {
        ergoOrganisationUnitBody.oe2.oenr = BookingState.ergoOrganisationUnit.organisation2Number;
      }
      if (SettingsState.agencyInformation.ergoOrganisationUnitType.organisation2Percent.visible) {
        ergoOrganisationUnitBody.oe2.percentage =
          BookingState.ergoOrganisationUnit.organisation2Percent;
      }
      if (SettingsState.agencyInformation.ergoOrganisationUnitType.tipster.visible) {
        ergoOrganisationUnitBody.oe2.tipster = BookingState.ergoOrganisationUnit.tipster;
      }
    } else {
      delete ergoOrganisationUnitBody.oe2;
    }

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.advertisingMaterialKey.visible) {
      ergoOrganisationUnitBody.advertisingMaterialKey =
        BookingState.ergoOrganisationUnit.advertisingMaterialKey;
    }
    if (!ergoOrganisationUnitBody.advertisingMaterialKey)
      delete ergoOrganisationUnitBody.advertisingMaterialKey;

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.wayOfAccess.visible) {
      ergoOrganisationUnitBody.wayOfAccessKey = BookingState.ergoOrganisationUnit.wayOfAccess;
    }
    if (!ergoOrganisationUnitBody.wayOfAccessKey) delete ergoOrganisationUnitBody.wayOfAccessKey;

    if (SettingsState.agencyInformation.ergoOrganisationUnitType.productionDST.visible) {
      ergoOrganisationUnitBody.productionDST = BookingState.ergoOrganisationUnit.productionDST;
    }
    if (!ergoOrganisationUnitBody.productionDST) delete ergoOrganisationUnitBody.productionDST;

    tmp.ergoOrganisationUnitIn = ergoOrganisationUnitBody;
  }
  return tmp;
}
